import { render, staticRenderFns } from "./output-value-list.vue?vue&type=template&id=8453c924&scoped=true&"
import script from "./output-value-list.vue?vue&type=script&lang=ts&"
export * from "./output-value-list.vue?vue&type=script&lang=ts&"
import style0 from "./output-value-list.vue?vue&type=style&index=0&id=8453c924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8453c924",
  null
  
)

export default component.exports